import Vue from 'vue';
import API from '@/api';
import moment from 'moment';
import * as types from '@/store/mutationTypes';
import _ from 'lodash';

const state = {
  companyId: null,
  list: [],
  loadingLoads: false,
  timestamp: null,
};

const getters = {
  list: qbState => qbState.list,
  companyId: qbState => qbState.companyId,
  timestamp: qbState => qbState.timestamp,
  loadingLoads: qbState => qbState.loadingLoads,
};

const mutations = {
  [types.SET_REPEATING_LOAD_TEMPLATES](loadState, { loads, companyId, loading }) {
    loadState.list = loads; // eslint-disable-line no-param-reassign
    loadState.companyId = companyId;// eslint-disable-line no-param-reassign
    loadState.loadingLoads = loading; // eslint-disable-line no-param-reassign
    loadState.timestamp = moment(); // eslint-disable-line no-param-reassign
  },
  [types.UPDATE_REPEATING_LOAD_TEMPLATE](loadState, loadData) {
    const loadIndex = _.findIndex(loadState.list,
      load => load.humanId === loadData.humanId);
    Vue.set(loadState.list, loadIndex, loadData);
  },
  [types.REMOVE_LOAD_TEMPLATE](loadState, loadId) {
    loadState.list = _.reject(loadState.list, { humanId: loadId }); // eslint-disable-line no-param-reassign
  },
};

const actions = {
  async getRepeatingLoadTemplates({ commit, dispatch }, companyId) {
    try {
      commit(types.SET_REPEATING_LOAD_TEMPLATES, { loads: [], companyId, loading: true });
      const response = await API.company.getRepeatLoadTemplates({ companyId });
      commit(types.SET_REPEATING_LOAD_TEMPLATES, { loads: response.data.items, companyId, loading: false });
    } catch (error) {
      dispatch('applications/setErrorNotification', {
        message: error.message,
      }, { root: true });
    }
  },
  async deleteLoadTemplate({ commit, dispatch }, loadId) {
    try {
      await API.company.deleteLoadTemplate(loadId);
      commit(types.REMOVE_LOAD_TEMPLATE, loadId);
    } catch (error) {
      dispatch('applications/setErrorNotification', {
        message: error.message,
      }, { root: true });
    }
  },
  updateLoadTemplate({ commit }, load) {
    commit(types.UPDATE_REPEATING_LOAD_TEMPLATE, load);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true,
};



// WEBPACK FOOTER //
// ./src/store/modules/repeatingLoadTemplates.js